import {
  ActionButton,
  ActionsGroup,
  Container,
  FAB,
  SearchFilter,
  SearchPagination,
  Table,
  usePagedQuery
} from '@elotech/components';
import { TableContainer, alert } from 'common/components';
import { useLoading } from 'common/hooks';
import { SqlModelo } from 'common/type';
import { useHistory } from 'react-router';

import { SqlModeloService } from '../../service';

const searchFields = [
  {
    label: 'Nome',
    type: 'STRING',
    name: 'nome'
  },
  {
    label: 'Código',
    type: 'NUMBER',
    name: 'codigo'
  },
  {
    label: 'Identificador',
    type: 'STRING',
    name: 'identificador'
  },
  {
    label: 'Prestação',
    type: 'BOOLEAN',
    name: 'prestacao'
  }
];

type Props = {
  service: SqlModeloService;
};

export const VariaveisListComponent = ({ service }: Props) => {
  const history = useHistory();
  const { loading, values, pagination, doSearch, doPagedSearch, doSortChange } =
    usePagedQuery({
      search: service.findAll,
      onError: error => Promise.reject(error)
    });
  const [isLoading, setLoading] = useLoading();

  const onRemove = (id: string, prestacao: boolean = false) => {
    if (!prestacao) {
      return alert({
        type: 'question',
        title: 'Excluir',
        text: 'Deseja mesmo excluir essa Variável/Sql?',
        onConfirm: () => {
          setLoading(service.deleteSql(id).then(() => doSearch()));
        }
      });
    }

    return alert({
      type: 'info',
      text: 'Variável/Sql do tipo Prestação não pode ser excluída.'
    });
  };

  const renderActionButtons = (
    id: string,
    prestacao: boolean,
    index: number
  ) => (
    <ActionsGroup>
      <ActionButton
        key="edit-button"
        label="Editar"
        icon="pencil-alt"
        data-cy={`edit-button-${index}`}
        onClick={() => history.push(`/variaveis/${id}`)}
      />
      <ActionButton
        key="remove-button"
        label="Remover"
        icon="trash"
        data-cy={`remove-button-${index}`}
        onClick={() => onRemove(id, prestacao)}
      />
    </ActionsGroup>
  );

  return (
    <>
      <Container title="Variáveis/Sql" icon="list">
        <TableContainer>
          <SearchFilter fields={searchFields} search={doSearch} />
          <Table
            values={values}
            loading={loading || isLoading}
            keyExtractor={(sql: SqlModelo) => `${sql.id}`}
            sortOnHeaderColumnClick={doSortChange}
            defaultSort={{ name: 'codigo,data', direction: 'desc' }}
          >
            <Table.Column
              sortable
              name="id"
              header="Código"
              value={(sql: SqlModelo) => sql.id}
            />
            <Table.Column
              sortable
              name="nome"
              header="Nome"
              value={(sql: SqlModelo) => sql.nome}
            />
            <Table.Column
              sortable
              name="identificador"
              header="Identificador"
              value={(sql: SqlModelo) => sql.identificador}
            />
            <Table.Column
              sortable
              name="prestacao"
              header="Prestacao"
              value={(sql: SqlModelo) => (sql.prestacao ? 'Sim' : 'Não')}
            />
            <Table.Column
              header=""
              value={(sql: SqlModelo, index: number) =>
                renderActionButtons(sql.id, sql.prestacao, index)
              }
            />
          </Table>
          {pagination && (
            <SearchPagination
              page={pagination}
              searchWithPage={doPagedSearch}
            />
          )}
        </TableContainer>
        <div className="btn-save">
          <FAB
            icon="plus"
            iconColor="white"
            title="Nova Variável/Sql"
            onClick={() => history.push('/variaveis/new')}
          />
        </div>
      </Container>
    </>
  );
};
